import { NgModule } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';

import { AdministrationRoutingModule } from './administration-routing.module';
import { UsersListComponent } from './components/user/users-list/users-list.component';
import { UsersListPageComponent } from './pages/user/users-list-page/users-list-page.component';
import { CerListPageComponent } from './pages/cer/cer-list-page/cer-list-page.component';
import { SiteListPageComponent } from './pages/site/site-list-page/site-list-page.component';
import { CerMapComponent } from '@reenstudio/app/shared/components/cer-map/cer-map.component';
import { MaterialModule } from '@reenstudio/app/material.module';
import { SiteListComponent } from './components/site/site-list/site-list.component';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CerListComponent } from './components/cer/cer-list/cer-list.component';
import { SharedModule } from '@reenstudio/app/shared/shared.module';
import { CerAddPageComponent } from './pages/cer/cer-add-page/cer-add-page.component';
import { CerAddEditComponent } from './components/cer/cer-add-edit/cer-add-edit.component';
import { CerEditPageComponent } from './pages/cer/cer-edit-page/cer-edit-page.component';
import { SiteAddEditComponent } from './components/site/site-add-edit/site-add-edit.component';
import { UserAddEditComponent } from './components/user/user-add-edit/user-add-edit.component';
import { UserAddPageComponent } from './pages/user/user-add-page/user-add-page.component';
import { UserEditPageComponent } from './pages/user/user-edit-page/user-edit-page.component';
import { SiteEditPageComponent } from './pages/site/site-edit-page/site-edit-page.component';
import { SiteAddPageComponent } from './pages/site/site-add-page/site-add-page.component';

@NgModule({
  declarations: [
    CerListPageComponent,
    CerAddPageComponent,
    CerEditPageComponent,
    SiteListPageComponent,
    SiteAddPageComponent,
    SiteEditPageComponent,
    UsersListPageComponent,
    UserAddPageComponent,
    UserEditPageComponent,
  ],
  imports: [
    CommonModule,
    AdministrationRoutingModule,
    CerMapComponent,
    SiteListComponent,
    SiteAddEditComponent,
    CerListComponent,
    TablerIconsModule,
    MaterialModule,
    SharedModule,
    CerAddEditComponent,
    UsersListComponent,
    UserAddEditComponent,
  ],
})
export class AdministrationModule {}
